import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { Global } from '@emotion/core'
import { Location } from '@reach/router'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import Header from '@/components/app/en/Header'
import Footer from '@/components/app/Footer'
import { rem } from '@/utils/helpers'

class DefaultLayout extends React.Component {
  render () {
    return (
      <Location>
        {({ location }) => (
          <Fragment>
            <Global styles={{
              body: {
                backgroundColor: this.props.theme.background.base,
                color: this.props.theme.text.base
              }
            }}/>
            <Root id="top">
              <Head>
                <Header color={this.props.headerColor} page={this.props.page} lang={this.props.lang} />
              </Head>
              <Main>
                {this.props.children}
              </Main>
              <Foot>
                <Footer lang={this.props.lang} />
              </Foot>
            </Root>
          </Fragment>
        )}
      </Location>
    )
  }
}

export default ThemeConsumer(DefaultLayout)

const Root = styled.div``

const Head = styled.div`
`

const Main = styled.div`
  margin: 0 auto;
  max-width: ${rem(1920)};
  box-sizing: content-box;
  position: relative;
  z-index: 1;
  height: 100%;
`

const Foot = styled.div`
  margin: 0 auto;
  max-width: ${rem(1920)};
  position: relative;
`
